// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Header_overlay__Hy_gO","active":"Header_active__Alxo9","header":"Header_header__0mdsD","spin":"Header_spin__rwrUQ","loader":"Header_loader__16A6g"};